// DropPin theme tokens. Single source for brand colour, neutrals,
// and common style objects. Imported by every screen so a tenant
// re-skin later only changes this file.
//
// v0.3.0 - rebrand from SiteSnag -> DropPin (keeping orange palette;
//          the pin glyph in <AppShell> is the new visual signature).
// v0.17.0 - InSite SaaS suite cohesion. All raw hex values are now
//           CSS variable references so they match every other app
//           (InSpecPDF, Stageit, Cockpit, InSpec). DropPin's old
//           lighter orange (#fb923c) replaced with the suite brand
//           (#e8650a — InSite construction orange).
//
//           The exported `theme` object still works the same way as
//           v0.3.0 — every screen that does `theme.brand` keeps
//           rendering — but `var(--brand-600)` resolves at render
//           time so changing tokens.css updates DropPin instantly.

export const theme = {
  brand:      'var(--brand-600)',
  brandDark:  'var(--brand-700)',
  bg:         'var(--surface-1)',
  surface:    'var(--surface-0)',
  border:     'var(--border)',
  text:       'var(--text-900)',
  textLight:  'var(--text-500)',
  success:    'var(--success)',
  warn:       'var(--warning)',
  danger:     'var(--danger)',
  hold:       'var(--hold)',     // v0.312.0 — On hold items
};

export const card = {
  background: theme.surface,
  border: `1px solid ${theme.border}`,
  borderRadius: 10,
  padding: 18,
  boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
};

export const input = {
  width: '100%',
  fontSize: 13,
  padding: '8px 12px',
  border: `1px solid ${theme.border}`,
  borderRadius: 6,
  background: theme.surface,
  color: theme.text,
  boxSizing: 'border-box',
  outline: 'none',
};

export const btnPrimary = {
  fontSize: 13,
  padding: '8px 16px',
  border: 'none',
  borderRadius: 6,
  background: theme.brand,
  color: 'var(--brand-on, #fff)',
  cursor: 'pointer',
  fontWeight: 600,
};

export const btnSecondary = {
  fontSize: 13,
  padding: '8px 14px',
  border: `1px solid ${theme.border}`,
  borderRadius: 6,
  background: theme.surface,
  color: theme.text,
  cursor: 'pointer',
};
